module.exports = __webpack_public_path__ + "static/media/geyser.df07bcc0.svg";